import React from 'react';

import Header from 'react-scale/components/elements/header';
import Navigation from 'react-scale/components/elements/navigation';
import HeroImage from 'react-scale/components/pages/image/hero';
import FeatureSection from 'react-scale/components/sections/features';
import HowItWorks from 'react-scale/components/elements/how-it-works';
import QualityAssurance from 'react-scale/components/sections/quality-assurance';
import TryBanner from 'react-scale/components/sections/cta/simple-centered';
import Footer from 'react-scale/components/elements/footer';

import {
  heroTitle,
  heroSubtitle,
  useCasesTitle,
  useCasesSubtitle,
  useCasesCases,
  hiwTitle,
  hiwSubtitle,
  featuresFeatures,
  qaSubtitle,
  qaTexts
} from 'react-scale/components/products/Content/Image';

import { themeDark } from 'react-scale/components/elements/header/header-themes';

const ThreeDSensorFusion = () => (
  <div className="text-white bg-black">
    <Header
      title="Image Annotation Solution | Scale AI"
      description="Image annotation for computer vision, NLP and classification models. From bounding box, segmentation to transcription, choose from a range of options."
      canonical="https://scale.com/image"
      ogImg="https://scale.com/static/img/website/image/facebook.png"
      theme={{
        ...themeDark
      }}
    />
    <Navigation
      color="text-white"
      title={{
        text: 'SUPPORTED DATA TYPE'
      }}
      links={[
        {
          text: 'Use Cases',
          href: '#use-cases'
        },
        {
          text: 'How It Works',
          href: '#how-it-works'
        },
        {
          text: 'Quality Assurance',
          href: '#quality-assurance'
        }
      ]}
      background="rgba(0, 0, 0, 0.7)"
      blur="8"
    />

    <HeroImage title={heroTitle} subtitle={heroSubtitle} />
    <div className="overflow-hidden">
      <FeatureSection
        id="use-cases"
        overtitle="Use Cases"
        title={useCasesTitle}
        subtitle={useCasesSubtitle}
        features={useCasesCases}
        cols={3}
      />
      <HowItWorks
        title={hiwTitle}
        subtitle={hiwSubtitle}
        productType="image"
        product="Scale Image"
        selectorStyle="small"
      />
      <FeatureSection features={featuresFeatures} cols={3} />
      <QualityAssurance bg="bg-neutral-900" subtitle={qaSubtitle} texts={qaTexts} />
      <TryBanner
        theme="dark"
        border
        cta={{
          buttons: [
            {
              href: '/demo',
              text: 'Book a Demo',
              type: 'primary'
            }
          ]
        }}
      />
      <Footer
        textColor="text-neutral-400"
        textHoverColor="text-white"
        borderColor="border-neutral-800"
        border
      />
    </div>
  </div>
);

ThreeDSensorFusion.theme = 'dark';

export default ThreeDSensorFusion;
